import { useEffect, useState } from 'react';

function getTargetTime(
  startTime: number | undefined,
  offsetInMilliseconds: number | undefined,
): number | undefined {
  if (!startTime) {
    return undefined;
  }

  return startTime + (offsetInMilliseconds ?? 0);
}

function getIsTimePassed(
  targetTime: number | undefined,
  currentTime: number,
): boolean {
  return targetTime !== undefined && currentTime >= targetTime;
}

export default function useIsTimePassed(
  startTime: number | undefined,
  offsetInMilliseconds: number | undefined = undefined,
): boolean {
  const [isTimePassed, setIsTimePassed] = useState(() =>
    getIsTimePassed(getTargetTime(startTime, offsetInMilliseconds), Date.now()),
  );

  useEffect(() => {
    const targetTime = getTargetTime(startTime, offsetInMilliseconds);
    const currentTime = Date.now();
    const hasTimePassed = getIsTimePassed(targetTime, currentTime);

    setIsTimePassed(hasTimePassed);

    if (targetTime === undefined || hasTimePassed) {
      return;
    }

    const timerId = window.setTimeout(() => {
      setIsTimePassed(true);
    }, targetTime - currentTime);

    return () => window.clearTimeout(timerId);
  }, [offsetInMilliseconds, startTime]);

  return isTimePassed;
}
